const $inject = ['$q', '$http', '$httpParamSerializer', 'moment'];

const authService = function ($q, $http, $httpParamSerializer, moment) {
  const service = {
    prevRoute: undefined,
    getUsername,
    login,
    logout,
    refresh,
    getOauth,
    clearOauth,
    getAccessToken,
    getRefreshToken,
    isAuthenticated,
    getFullname,
    getInitials
  };

  let CLIENT_ID = '40cd37d4-267a-43ca-99d3-f5bd67b8e58d';

  function getUsername() {
    return service.getOauth().username;
  }

  function getFullname() {
    return service.getOauth().fullname;
  }

  function getInitials() {
    var fullname = getFullname();
    if(fullname === null ||fullname === undefined) return '--';
    
    var words = fullname.split(' ');
    return words.map((word) => {
      return word[0];
    }).join('');
  }

  function login(username, password) {
    let data = {
      client_id: CLIENT_ID,
      grant_type: 'password',
      username: username,
      password: password
    };

    let req = {
      method: 'POST',
      url: `${endPointUrl}/Token`,
      headers: {
        'Content-type': 'application/x-www-form-urlencoded; charset=utf-8'
      },
      data: $httpParamSerializer(data)
    };

    return $http(req).then(function (data) {
      let oauth = data.data;
      oauth.expires_at = moment().add(oauth.expires_in, 's').format('x');
      oauth.username = username;

      localStorage.setItem('oauth', JSON.stringify(oauth));
    });
  }

  function logout() {
    let deferred = $q.defer();

    service.clearOauth();

    deferred.resolve();

    return deferred.promise;
  }

  function refresh() {
    let data = {
      client_id: CLIENT_ID,
      grant_type: 'refresh_token',
      refresh_token: getRefreshToken()
    };

    let req = {
      method: 'POST',
      url: `${endPointUrl}/Token`,
      headers: {
        'Content-type': 'application/x-www-form-urlencoded; charset=utf-8'
      },
      data: $httpParamSerializer(data)
    };

    return $http(req).then(function (data) {
      let oauth = {};
      oauth.refresh_token = data.refresh_token;
      oauth.access_token = data.access_token;

      localStorage.setItem('oauth', JSON.stringify(oauth));
    });
  }

  function getOauth() {
    return JSON.parse(localStorage.getItem('oauth'));
  }

  function clearOauth() {
    return localStorage.removeItem('oauth');
  }

  function getAccessToken() {
    var oauth = service.getOauth();

    return oauth ? oauth.access_token : '';
  }

  function getRefreshToken() {
    var oauth = service.getOauth();

    return oauth ? oauth.refresh_token : '';
  }

  function isAuthenticated() {
    var oauth = service.getOauth();

    return oauth && oauth.expires_at && oauth.expires_at > Date.now();
  }

  return service;
};

authService.$inject = $inject;

export default authService;



// WEBPACK FOOTER //
// ./src/services/authService.js